import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GiveawayService } from '@app/services/giveaways/giveaways.service';
import { GiveawaysDataSource } from '@app/services/giveaways/giveaways.datasource';
import { MatPaginator } from '@angular/material/paginator';
import { tap } from 'rxjs/operators';

import * as moment from 'moment';
import { Dictionary } from '@app/_models/shared.model';
import { Router } from '@angular/router';

@Component({
  selector: 'giveaways-list',
  templateUrl: './giveaways-list.component.html',
  styleUrls: ['./giveaways-list.component.scss'],
})
export class GiveawaysListComponent implements OnInit, AfterViewInit {
  constructor(
    private giveawayService: GiveawayService,
    private _router: Router
  ) {}
  displayedColumns = ['name', 'drawTime', 'status'];
  giveawaysList: GiveawaysDataSource;
  selectedStatus = -1;
  totalRecords = 0;
  states: Dictionary[] = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngOnInit(): void {
    this.giveawaysList = new GiveawaysDataSource(this.giveawayService);
    this.giveawaysList
      .loadGiveaways()
      .then((total: number) => (this.totalRecords = total));
    this.giveawayService.getStates().subscribe((states: Dictionary[]) => {
      this.states = [
        {
          name: 'Todos',
          value: -1,
        },
        ...states,
      ];
    });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        tap(() =>
          this.giveawaysList.loadGiveaways(
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.selectedStatus
          )
        )
      )
      .subscribe();
  }

  loadGiveawayListByStatus(): void {
    this.giveawaysList
      .loadGiveaways(
        this.paginator.pageIndex,
        this.paginator.pageSize,
        this.selectedStatus
      )
      .then((total: number) => (this.totalRecords = total));
  }

  parseIsoToDateTime(isoDate): string {
    return moment(isoDate, moment.ISO_8601).format('DD/MM/YYYY HH:mm');
  }

  goToGiveawayDetail(id) {
    this._router.navigate([`/giveaways/${id}`]);
  }

  getItemStatus(statusId: number): string {
    const status = this.states.find(e => {
      return e.value === statusId;
    });
    if (status) {
      return status.name;
    }
    return '';
  }
}
